<template>
    <div class="animated flipInX users-coins-overlay-container"
         :class="{'flipOutX':close, 'animation-delay': !close}"
         @click="close = true">
        <div class="rich-svg-container">
            <img src="https://res.cloudinary.com/dspi5zyaa/image/upload/v1638874965/eh-platform/icons/smashicons_business_rich-icon-148-retro.svg" class="rich-svg" alt="An icon with a big moneybag"/>
        </div>
        <div style="height: 7rem; float: left; padding: 0 2rem; ">
            <h4 style="font-size: 1.5rem; margin-top: 1.3rem;">Dein Guthaben: <br>
                <UserCoinsComponent class="coins-component"/>
            </h4>
        </div>
        <div class="clearfix"></div>
    </div>
</template>

<script>
    import UserCoinsComponent from "./UserCoinsComponent";

    export default {
        name: "UserCoinsOverlay",
        components: {UserCoinsComponent},
        data() {
            return {
                close:false,
            }
        }
    }
</script>

<style scoped>
    .rich-svg {
        height: 6rem;
        margin: 0.5rem;
        padding: 0 0rem;
    }

    .rich-svg-container {
        height: 7rem;
        width: 7rem;
        background-color: #E9F2FC;
        float: left;
        border-radius: 10px 0 0 10px;
    }

    .coins-component {
        display: inline-block;
        font-size: 2.5rem;
    }

    .animation-delay {
        animation-delay: 1s;
    }

    .users-coins-overlay-container {
        border-radius: 10px;

        display: inline-block;
        box-shadow: 0 10px 30px rgba(50, 50, 93, .17), 0 5px 10px rgba(0, 0, 0, .17);
        position: fixed;
        z-index: 2000;
        bottom: 20px;
        background-color: var(--coins-background);
    }
</style>
